module Meevo.Plugins.PointPromotionCampaign {
    class ProductsFilterController {
        static $inject = [
            "meevo.components.modal.ModalService", "$mdDialog", "context"
        ];

        private manufacturerId: string;
        private subCategoryId: string;

        constructor(private modalService: Meevo.Components.Modal.IModalService, private $mdDialog, private context) {
            this.manufacturerId = context.manufacturerId;
            this.subCategoryId = context.subCategoryId;
        }

        clearFilter = (): void => {
            this.context.manufacturerId = null;
            this.context.subCategoryId = null;
            this.closeModal();
        }

        applyFilter = (): void => {
            this.context.manufacturerId = this.manufacturerId;
            this.context.subCategoryId = this.subCategoryId;
            this.closeModal();
        }

        closeModal = (): void => {
            this.$mdDialog.cancel();
        }
    }

    angular.module("meevo.plugins.pointPromotionCampaign")
        .controller("meevo.plugins.pointPromotionCampaign.ProductsFilterController", ProductsFilterController);
}
